import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    logoDisplay: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        border: '1px dashed #C6CCD6',
        borderRadius: '8px',
        backgroundColor: '#FBFCFD',
        padding: '26px',
        gap: '26px',
    },

    imageTitle: {
        marginBottom: '10px !important',
    },

    errorText: {
        color: '#B42318',
        marginTop: '10px',
    },

    imageBox: {
        // True to the recommended upload dimensions (300x250, 6:5) rather than
        // a scaled/responsive box, so what admins see here matches the actual
        // size their cover photo will render at.
        width: '300px',
        height: '250px',
        flexShrink: 0,
        border: '1px solid #E4E7EC',
        borderRadius: '6px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
    },

    image: {
        width: '100%',
        height: '100%',
        // imageBox is a flex container and this img is its flex item — without
        // these, the item's default min-width/min-height (the image's own
        // intrinsic size) can override width/height above and break objectFit,
        // letting the image stretch instead of cropping to fit the box.
        minWidth: 0,
        minHeight: 0,
        objectFit: 'cover',
        display: 'block',
    },

    imagePlaceholder: {
        width: '64px',
        height: '64px',
        objectFit: 'contain',
        display: 'block',
    },

    imageControls: {
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        minWidth: '190px',
    },

    imageControlsLabel: {
        fontWeight: 600,
    },

    imageControlsButtons: {
        display: 'flex',
        gap: '10px',
    },

    iconButton: {
        width: '36px',
        height: '36px',
    },

    imageHint: {
        fontSize: '0.75rem',
        color: '#0000008a',
    },
}));
